import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const PipelineConfigModelSchema = z
  .object({
    id: z.string(),
    pipeline: z.string().nullish(),
    stage: z.string().nullish(),
    default: z.boolean().nullish(),
    visible_kb: z.boolean().nullish(),
    drop_option_kb: z.boolean().nullish(),
    max_age_kb: z.number().nullish(),
    sequence_kb: z.number().nullish(),
    sequence_tbl: z.number().nullish(),
    visible_tbl: z.boolean().nullish(),
    drop_option_tbl: z.boolean().nullish(),
    max_age_tbl: z.number().nullish(),
    colour: z.string().nullish(),
    stage_warn_days: z.number().nullish(),
    stage_warn_colour: z.string().nullish(),
    stage_crit_days: z.number().nullish(),
    stage_crit_colour: z.string().nullish(),
    show_age_counters: z.boolean().nullish()
  })
  .strict()

export const PipelineConfigModelFields = makeFieldKeys(PipelineConfigModelSchema)

export type PipelineConfigModel = z.infer<typeof PipelineConfigModelSchema>

function validatePipelineConfigModel(data: unknown): PipelineConfigModel {
  try {
    return validateWithZodSchema(PipelineConfigModelSchema, data, 'pipeline config model')
  } catch (error) {
    throw new Error(`Pipeline config model validation failed: ${error}`)
  }
}
